export default "__VITE_ASSET__CFNA_ekv__"